import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

export type KestrelTutorialContextType = {
  tutorialIndex: number
  setTutorialIndex: Dispatch<SetStateAction<number>>
  forceViewControlsSubmenuOpen: boolean
  setForceViewControlsSubmenuOpen: Dispatch<SetStateAction<boolean>>
  showTutorial: boolean
  setShowTutorial: Dispatch<SetStateAction<boolean>>
}

export const KestrelTutorialContext = createContext<
  KestrelTutorialContextType | undefined
>(undefined)

const STORAGE_KEY = 'kestrelTutorialShow'

const getInitialShowTutorial = (): boolean => {
  if (typeof window === 'undefined') return true
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === null) return true
  return stored === 'true'
}

export const KestrelTutorialProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [tutorialIndex, setTutorialIndex] = useState<number>(0)
  const [forceViewControlsSubmenuOpen, setForceViewControlsSubmenuOpen] =
    useState<boolean>(false)
  const [showTutorial, setShowTutorial] = useState<boolean>(
    getInitialShowTutorial
  )

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, String(showTutorial))
    }
  }, [showTutorial])

  const value: KestrelTutorialContextType = {
    tutorialIndex,
    setTutorialIndex,
    forceViewControlsSubmenuOpen,
    setForceViewControlsSubmenuOpen,
    showTutorial,
    setShowTutorial,
  }

  return (
    <KestrelTutorialContext.Provider value={value}>
      {children}
    </KestrelTutorialContext.Provider>
  )
}

export const useKestrelTutorialContext = () => {
  const context = useContext(KestrelTutorialContext)
  if (!context)
    throw new Error(
      'useKestrelTutorialContext() must be used within KestrelTutorialProvider'
    )
  return context
}
